import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SortNumber from "./data/SortNumber"
import FileName from "./data/FileName"
import Statics from "./data/Statics"
import ShippingCarrier from "./data/ShippingCarrier"
import DateCreate from "./data/DateCreate"
import Status from "./data/Status"
import Actions from "./data/Actions"

class JobTableRow extends Component {
    render() {
        const {item, index, limit, page, getListingJob} = this.props

        return (
            <tr className="JobTableRow">
                <SortNumber limit={limit} page={page} index={index}/>
                <FileName filename={item.filename} fileUrl={item.file_url}/>
                <Statics result={item.result}/>
                <ShippingCarrier shippingCarrier={item.shipping_carrier}/>
                <DateCreate date={item.created_at}/>
                <Status status={item.status} message={item.message}/>
                <Actions item={item} getListingJob={getListingJob}/>
            </tr>
        )
    }
}

JobTableRow.propTypes = {
    limit: PropTypes.number,
    page: PropTypes.number,
    getListingJob: PropTypes.func,
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired
}

export default JobTableRow